export default {
    Products: [
        {
            Id: '1',
            Code: "Iphone12",
            Name: "Iphone 12",
            Description: "ĐT Iphone 12",
            Quantity: 100,
            Price: 10000000,
            Status: 1,
            Category: 1,
            Supplier: "FPT",
            OrderTotal: 10,
        },
        {
            //Gennerate cho tôi 1 đối tượng mới đầy đủ
            Id: '2',
            Code: "Iphone11",
            Name: "Iphone 11",
            Description: "ĐT Iphone 11",
            Quantity: 100,
            Price: 9000000,
            Status: 1,
            Category: 1,
            Supplier: "FPT",
            OrderTotal: 10,
        }
    ]
}